const Title = (props) => {
  const mainTitleHeight = props.height * 0.5;
  const subTitleHeight = (props.height - mainTitleHeight);

  const content = {
    colombia: {
      title: "Colombia",
      subtitle: "Peace Talks, Worsening Violence, and a Deeply Fragmented Conflict Landscape",
    },
    caucasus: {
      title: "Central Asia & the Caucasus",
      subtitle: "Threat of Sporadic Outbreaks of Violence Across the Region",
    },
    drc: {
      title: "Democratic Republic of the Congo",
      subtitle: "Rising tensions with Rwanda amidst escalating violence and the December elections",
    },
    haiti: {
      title: "Haiti",
      subtitle: "Expanding Gang Activity Amid Persisting Political Instability",
    },
    kurdistan: {
      title: "Kurdistan",
      subtitle: "High Risk of escalation of violence in Kurdish regions of Iraq and Syria amid domestic political calculations in Turkey and Iran",
    },
    myanmar: {
      title: "Myanmar",
      subtitle: "Continued Opposition to the Junta Amid Increasing Civilian Targeting by the Military",
    },
    nigeria: {
      title: "Nigeria",
      subtitle: "Insecurity Threatens Nigeria’s Historic Elections",
    },
    sahel: {
      title: "Sahel",
      subtitle: "Geopolitical transition at the center of an ever-worsening crisis",
    },
    ukraine: {
      title: "Ukraine",
      subtitle: "A Looming Escalation as Ukraine Enters Second Year of War",
    },
    yemen: {
      title: "Yemen",
      subtitle: "Embers in the Ashes: Will Conflict Reignite in 2023?",
    },
  };

  return (
    <div
      id="titleContainer"
      className="container"
      style={{
        height: props.height,
        width: props.width,
        margin: "auto",
        background: "#ededed",
      }}
    >
      <div
        id="mainTitle"
        className="text-white titleSection"
        style={{ height: mainTitleHeight, background: "#12425e" }}
      >
        <h2>Conflict Watchlist 2023: <strong>{content[props.focusCountry].title}</strong></h2>
      </div>
      <div
        id="subTitle"
        className="titleSection"
        style={{ height: subTitleHeight, background: "#f0f0f0" }}
      >
        <p>{content[props.focusCountry].subtitle}</p>
      </div>
      {/* <div
        id="date"
        className="titleSection"
        style={{ height: subTitleHeight, background: "#ffffff" }}
      >
        <p>10 January - 30 June 2022</p>
      </div> */}
    </div>
  );
};

export default Title;
